/* eslint-disable react/prefer-stateless-function */
import React from "react";
import Language from "../lib/Language";
import ScratchpadList from "./ScratchpadList";
import { Scratchpad } from "../models/Scratchpad";

type TPinboardPaneProps = {
    scratchpad: Scratchpad;
    showExtraInfo: boolean;
};

class PinboardPane extends React.Component<TPinboardPaneProps> {
    _isRemoveClick?: boolean;

    render() {
        const onObjectSelected = (object) => {
            if (this._isRemoveClick) {
                this.props.scratchpad.removeObjects([object.id]);
                // The list is read off the scratchpad as this renders, so the
                // removal only needs a new render, not a state key to hold it.
                this.forceUpdate();
            }
            this._isRemoveClick = false;
        };
        const unpinButton = (
            <button
                className="deprecated unpinButton"
                onClick={() => {
                    this._isRemoveClick = true;
                }}
                title={Language.get("nc_remove_from_pinboard")}
            />
        );
        return (
            <div className="pinboardPane">
                <h2>{Language.get("nc_pinboard")}</h2>
                <p>
                    {Language.get("nc_pinboard_info")}
                    <br />
                    <a
                        target="_blank"
                        href="https://academy.timeedit.com/guides-tutorials/pinboard"
                    >
                        {Language.get("nc_pinboard_on_te_academy")}
                    </a>
                </p>
                <ScratchpadList
                    flex={true}
                    showExtraInfo={this.props.showExtraInfo}
                    objects={this.props.scratchpad.getObjects()}
                    onObjectSelected={onObjectSelected}
                    allowMultiSelection={true}
                    hoverButton={unpinButton}
                />
            </div>
        );
    }
}

export default PinboardPane;
